<div class="menu-clinica-container">
	<nav class="menu-clinica">
		<ul>
			<li><a [routerLink]="['../clinica']" [routerLinkActive]="['menuActivo']"><fa-icon [icon]="faUserAlt"></fa-icon></a></li>
			<li><a [routerLink]="['../formulario']" [routerLinkActive]="['menuActivo']"><fa-icon [icon]="faStickyNote"></fa-icon></a></li>
			<li><a [routerLink]="['../consulta']" [routerLinkActive]="['menuActivo']"><fa-icon [icon]="faCog"></fa-icon></a></li>
			<!-- <li><a [routerLink]="['../home']" [routerLinkActive]="['menuActivo']"><fa-icon [icon]="faHome"></fa-icon></a></li> -->
			<li><a [routerLink]="['../home']" [routerLinkActive]="['menuActivo']"><fa-icon [icon]="faPowerOff"></fa-icon></a></li>
		</ul>
	</nav>
</div>